<template>
  <div>
    <table class="venti__table6B">
      <thead>
        <tr>
          <td colspan="7" class="table-heading-venti6B">Ventilators</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color:#dedede">Orientation</td>
          <!-- <td style="background-color:#dedede">Components</td> -->
          <td style="background-color:#dedede">Material</td>
          <td style="background-color:#dedede">Area</td>
          <td style="background-color:#dedede">U-value</td>
          <td style="background-color:#dedede">Orientation Factor</td>
          <td style="background-color:#dedede">A*B*C</td>
        </tr>
        <tr v-for="(venti, j) in step3C.ventilatorArrObj" :key="venti.orientation">
          <template v-if="venti.calcGlassArea !== 0 && venti.calcGlassArea !== ''">
            <td>{{ venti.orientation }}</td>
            <td style="background-color: #c4def5">{{ venti.selectedGlassMaterial.material || `-----` }}</td>
            <!-- <td >{{ orient.selectedNonOpaqueMaterial.material || `-----` }}</td> -->
            <td>{{ venti.calcGlassArea }}</td>
            <td>{{ venti.uValueMaterial || +0 }}</td>
            <td>{{ venti.orientFactor }}</td>
            <td style="background-color: #c8f0e0">{{ venti.abcVentilator || +0 }}</td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  computed: {
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
  },
};
</script>

<style lang="scss">
.venti__table6B {
  padding: 12px;
  width: 100%;
  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-venti6B {
    background-color: #c4def5;
    padding: 4px;
    font-size: 12px;
    font-weight: 500;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 2px;
    text-align: center;
    font-size: 11px;
  }
}
</style>
